import { useLayoutEffect } from "react";
import { Stack, useRouter } from "expo-router";
import { useUnistyles } from "react-native-unistyles";
import { ActivityPage } from "@visioni/a3s-activity/app";
import { useActivityPageProps } from "@src/features/activity/hooks/useActivityPageProps";
import { useIsTenantAdmin } from "@visioni/a3s-access/app";
import { FEATURE_FLAGS, useBooleanFlag, useFeatureFlagsStore } from "@src/services/feature-flags/feature-flags";

export default function ActivityScreen() {
  const router = useRouter();
  const { theme } = useUnistyles();
  const activityProps = useActivityPageProps();

  const isActivityEnabled = useBooleanFlag(FEATURE_FLAGS.ACTIVITY_TAB);
  const flagsReady = useFeatureFlagsStore((s) => s.isInitialized);
  const { isTenantAdmin, isLoading: permissionsLoading } = useIsTenantAdmin();
  const canViewActivity = isActivityEnabled && isTenantAdmin;

  useLayoutEffect(() => {
    if (flagsReady && !permissionsLoading && !canViewActivity) {
      router.replace("/overview");
    }
  }, [flagsReady, permissionsLoading, canViewActivity, router]);

  return (
    <>
      <Stack.Screen
        options={{
          title: "Activity",
          headerStyle: { backgroundColor: theme.colors.background },
          headerTintColor: theme.colors.text,
          headerBackButtonDisplayMode: "minimal",
          headerShadowVisible: false,
        }}
      />
      <ActivityPage {...activityProps} />
    </>
  );
}
